import {Component, Input, OnInit} from '@angular/core';
import {Address} from "../../services/models/User/Address";

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.scss'],
})
export class AddressFormComponent implements OnInit {
  @Input() Address!: Address;
  constructor() { }

  ngOnInit() {}

}
